import { create } from 'zustand';

interface AuthState {
  accessToken: string | null;
  expiresAt: string | null;
  role: string | null;
  setTokens: (accessToken: string, expiresAt: string, role: string) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  expiresAt: null,
  role: null,
  setTokens: (accessToken, expiresAt, role) =>
    set({ accessToken, expiresAt, role }),
  clear: () => set({ accessToken: null, expiresAt: null }),
}));
